import React, { useState } from "react";
import { StepShell, Field, Chips, YesNo, SelectNative } from "./WizardUI";
import { CONTENT_TYPES, TONES } from "./constants";

export default function Step5ContentPrefs({ saved, station, onSave, onBack, onSkip, busy }) {
  const p = { ...((station || {}).content_prefs || {}), ...(saved || {}) };
  const [f, setF] = useState({
    types: p.types || [],
    tone: p.tone || station?.content_tone || "",
    length: p.length || "medium",
    use_emojis: p.use_emojis ?? true,
    include_hashtags: p.include_hashtags ?? true,
    mention_station: p.mention_station ?? true,
    require_approval: p.require_approval ?? true,
    auto_publish: p.auto_publish ?? false,
  });
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));

  return (
    <StepShell step={5} title="AI content preferences"
      subtitle="Choose what BroadcastFlow AI should create for you and how it should sound."
      onBack={onBack} onContinue={() => onSave(f)} onSkip={onSkip} busy={busy}>
      <Field label="Content types to create" hint="Select everything you want the AI to handle.">
        <Chips options={CONTENT_TYPES} values={f.types} onChange={set("types")} testidPrefix="onb-ct" />
      </Field>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Preferred writing tone">
          <SelectNative options={TONES.filter((t) => t !== "Custom")} value={f.tone} onChange={set("tone")}
            placeholder="Choose a tone…" testid="onb-prefs-tone" />
        </Field>
        <Field label="Default content length">
          <SelectNative options={[{ v: "short", l: "Short & punchy" }, { v: "medium", l: "Medium" }, { v: "long", l: "Long & detailed" }]}
            value={f.length} onChange={set("length")} testid="onb-prefs-length" />
        </Field>
      </div>
      <div className="grid sm:grid-cols-2 gap-2.5">
        <YesNo label="Use emojis" value={f.use_emojis} onChange={set("use_emojis")} testid="onb-yn-emojis" />
        <YesNo label="Include hashtags" value={f.include_hashtags} onChange={set("include_hashtags")} testid="onb-yn-hashtags" />
        <YesNo label="Mention the station name automatically" value={f.mention_station} onChange={set("mention_station")} testid="onb-yn-mention" />
        <YesNo label="Require approval before publishing" value={f.require_approval} onChange={set("require_approval")} testid="onb-yn-approval" />
        <YesNo label="Allow automatic publishing" value={f.auto_publish} onChange={set("auto_publish")} testid="onb-yn-autopublish" />
      </div>
    </StepShell>
  );
}
